import { TextAreaTemplate } from '@templates';
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import { RoutesList } from '../../../../routes/Routes';
import { useSignsBollardsStore } from '../../../../hooks';
import { ErrorMessages } from '@types';
import { parseZodErrors } from '@utils';
import { ZodError } from 'zod';
import { MAX_LENGTH } from '@shared/constants';
import {} from '../../../../constants/signsBollards';

export const DescribeTheIssue = () => {
  const {
    update,
    data: { moreDetails },
  } = useSignsBollardsStore();

  const [textInput, setTextInput] = useState(moreDetails);
  const [errorMessages, setErrorMessages] = useState<ErrorMessages[]>([]);
  const navigate = useNavigate();
  const pageTitle = 'Describe the issue';
  const description =
    "Tell us more about the issue you're reporting, for example, a bollard is blocking the pavement.";
  const errorPath = 'moreDetails';

  const handleChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    setTextInput(event.target.value);
    setErrorMessages([]);
  };

  const buttonNext = {
    onClick: () => {
      setErrorMessages([]);
      try {
        if (textInput === '') {
          setErrorMessages([
            {
              path: errorPath,
              message: 'Enter details about the issue.',
            },
          ]);
          return;
        }
        if (textInput.length > MAX_LENGTH) {
          setErrorMessages([
            {
              path: errorPath,
              message:
                'Details about the issue must be 500 characters or less.',
            },
          ]);
          return;
        }

        update('moreDetails', textInput);
        navigate(RoutesList.UPLOAD_PHOTO);
      } catch (error) {
        const validationErrors = parseZodErrors(error as ZodError);
        setErrorMessages(
          validationErrors.map((error: ErrorMessages) => ({
            ...error,
            href: error.path,
          })),
        );
      }
    },
  };

  const buttonPrevious = {
    onClick: () => {
      navigate(RoutesList.ISSUE_TYPE);
    },
  };

  return (
    <TextAreaTemplate
      initialTextValue={textInput}
      labelText={pageTitle}
      description={description}
      onChange={handleChange}
      buttonNext={buttonNext}
      buttonPrevious={buttonPrevious}
      maxLength={MAX_LENGTH}
      errorPath={errorPath}
      errorMessages={errorMessages}
    />
  );
};
